import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CommonThreadLocalClass;
function CommonThreadLocal() {
  if (CommonThreadLocalClass === VOID) {
    class $ {
      constructor() {
        this.c14_1 = null;
      }
      d14() {
        return this.c14_1;
      }
      e14(value) {
        this.c14_1 = value;
      }
    }
    initMetadataForClass($, 'CommonThreadLocal', CommonThreadLocal);
    CommonThreadLocalClass = $;
  }
  return CommonThreadLocalClass;
}
function commonThreadLocal(name) {
  return new (CommonThreadLocal())();
}
//region block: exports
export {
  commonThreadLocal as commonThreadLocal18t70xomalc6z,
};
//endregion

//# sourceMappingURL=ThreadLocal.mjs.map
